import {
	MY_SUCCESS_LOADING,
	RECEIVED_MY_SUCCESS_ITEMS,
	RECEIVED_MY_SUCCESS_LEVELS,
	REQUEST_MY_SUCCESS,
	REQUEST_MY_SUCCESS_LEVELS,
} from './mySuccess.actionTypes';

export const actionCreators = {
	doRequestMySuccess: () => ({
		type: REQUEST_MY_SUCCESS,
	}),
	doRequestMySuccessLoading: () => ({
		type: MY_SUCCESS_LOADING,
	}),
	doRequestMySuccessSuccess: (contents: any) => ({
		type: RECEIVED_MY_SUCCESS_ITEMS,
		contents,
	}),
	doRequestMySuccessLevels: (contents: any) => ({
		type: REQUEST_MY_SUCCESS_LEVELS,
		contents,
	}),
	doRequestMySuccessLevelsSuccess: (allLevels: any[]) => ({
		type: RECEIVED_MY_SUCCESS_LEVELS,
		allLevels,
	}),
};

export type MySuccessActionType =
	| ReturnType<typeof actionCreators.doRequestMySuccess>
	| ReturnType<typeof actionCreators.doRequestMySuccessLoading>
	| ReturnType<typeof actionCreators.doRequestMySuccessSuccess>
	| ReturnType<typeof actionCreators.doRequestMySuccessLevels>
	| ReturnType<typeof actionCreators.doRequestMySuccessLevelsSuccess>;
